var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,_vm._g(_vm._b({tag:"component",attrs:{"enter-active-class":_vm.enterClass,"move-class":"slide-move","leave-active-class":_vm.leaveClass}},'component',_vm.$attrs,false),_vm.hooks),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }